import { CSSLength, isCSSLength, } from "./CSSLength.js";
import { CSSPercentage, isCSSPercentage, } from "./CSSPercentage.js";
export function toSize(value, baseFontSizePx) {
    if (isCSSLength(value) || isCSSPercentage(value)) {
        return value;
    }
    try {
        return CSSLength.from(value, baseFontSizePx);
    }
    catch (error) {
        if (error instanceof TypeError === false) {
            throw error;
        }
    }
    if (baseFontSizePx !== undefined) {
        throw new TypeError(`css.toSize: Unrecognized value: ${value} with baseFontSizePx: ${baseFontSizePx}`);
    }
    try {
        return CSSPercentage.from(value);
    }
    catch (error) {
        if (error instanceof TypeError === false) {
            throw error;
        }
    }
    throw new TypeError(`css.toSize: Unrecognized value: ${value}`);
}
